<template>
    <dialog-template
        headerTitle="多倍积分设置"
        :visible.sync="dialogTableVisible"
        :width="'480px'"
        :append-to-body="true">
        <div>
            <div>
                <div class="item-wrapper">
                    <span class="item-left">频率：</span>
                    <div class="item-right">
                        <el-radio v-model="forms.frequency"
                            class="mr-20"
                            :label="0">每周</el-radio>
                        <el-radio v-model="forms.frequency" :label="1">每月</el-radio>
                    </div>
                </div>
                <div class="item-wrapper">
                    <span class="item-left">时间：</span>
                    <div class="item-right">
                        <week-picker v-if="forms.frequency === 0"
                            :weekCache.sync="forms.weekdays"/>
                        <date-picker v-if="forms.frequency === 1"
                            :dateCache.sync="forms.monthdays"/>
                    </div>
                </div>
                <div class="item-wrapper">
                    <span class="item-left">积分倍数：</span>
                    <div class="item-right">
                        <el-input v-model="forms.multiplier" @input="limit(forms, 'multiplier')" placeholder="请输入1-10之前的数字，最多一位小数">
                            <span slot="suffix" class="color-333">倍</span>
                        </el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer fx-h-center" slot="footer">
            <el-button
                type="primary"
                size="medium"
                :disabled="!isCanSubmit"
                @click="confirm">
                确认
            </el-button>
            <el-button type="default"
                size="medium"
                @click="cancel">取消</el-button>
        </div>
    </dialog-template>
</template>

<script lang="ts">
import Vue from 'vue'
import { createComponent, ref, reactive, computed } from '@vue/composition-api'
import $fetch from '@/api'
import DatePicker from './date_picker.vue'
import WeekPicker from './week_picker.vue'
import { openMessage } from '@/utils/system'
import { inputLimit } from '../../../../utils'

export default createComponent({
    props: {
        activity: {}
    },
    setup(props: {
        activity: any
    }, ctx) {
        const dialogTableVisible = ref(false)
        const forms = ref({
            frequency: 0, // 0 每周 1 每月
            weekdays: [],
            monthdays: [],
            multiplier: ""
        })

        const isCanSubmit = computed(() => {
            return forms.value.multiplier && forms.value.multiplier.toString().length > 0
        })

        const limit = inputLimit(/^([1-9]{1}|(10))(\.\d{0,1})?$/)

        function open() {
            dialogTableVisible.value = true
            init()
        }

        function init() {
            forms.value = JSON.parse(JSON.stringify(props.activity))
            forms.value.frequency = forms.value.frequency || 0
        }

        function confirm() {
            $fetch.post({
                url: '/activity/updatepointbooster',
                params: {
                    weekdays: forms.value.frequency === 0 ? forms.value.weekdays : null,
                    monthdays: forms.value.frequency === 1 ? forms.value.monthdays : null,
                    multiplier: forms.value.multiplier,
                }
            }).then(data => {
                dialogTableVisible.value = false
                ctx.emit('update')
                openMessage("success", "设置成功")
            }).catch(e => {
                openMessage("error", e.message || '设置失败')
            })
        }

        function cancel() {
            dialogTableVisible.value = false
        }

        return {
            forms,
            dialogTableVisible,
            open,
            confirm,
            cancel,
            limit,
            isCanSubmit
        }
    },

    components: {
        DatePicker,
        WeekPicker
    }
})
</script>

<style lang="scss" scoped>
.item-wrapper {
    display: flex;
    align-items: center;
    
    & + .item-wrapper {
        margin-top: 20px;
    }

    .item-left {
        flex: 0 0 80px;
    }

    .item-right {
        flex: 1;
    }
}
</style>